// Botão "Copiar" que vira "Copiado ✓" por 2 segundos (0.65, Texto 4 E).
import { useEffect, useRef, useState } from 'react';
import { Chip } from './ui';
import { copiarTexto } from '../lib/copiar';
import { t } from '../lib/i18n';

export function BotaoCopiar({ texto, rotulo, cor }: { texto: string; rotulo: string; cor: string }) {
  const [ok, setOk] = useState(false);
  const tm = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (tm.current) clearTimeout(tm.current); }, []);
  return <Chip small cor={cor} on={ok} label={ok ? t('Copiado ✓') : '📋 ' + rotulo} onPress={async () => {
    if (await copiarTexto(texto)) { setOk(true); if (tm.current) clearTimeout(tm.current); tm.current = setTimeout(() => setOk(false), 2000); }
  }} />;
}
